import Header from '../../../Components/Header'
import { Helmet } from 'react-helmet'
import TableLayout from './TableLayout'

const CustomerList = () => {

    return (
        <div className='d-flex flex-column' style={{ minHeight: '99.7vh' }}>
            <Helmet>
                <title>Customer Entry Form List</title>
            </Helmet>
            <Header />
            <TableLayout />
        </div>
    )
}

export default CustomerList